import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Tab as MuiTab } from '@mui/material';
export function Tab({ sx, children, ...props }) {
    return /*#__PURE__*/ _jsx(MuiTab, {
        sx: sx,
        label: children,
        ...props
    });
}

//# sourceMappingURL=Tab.js.map